import React from 'react';
import Checkbox from 'components/atoms/checkbox';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ManagementState } from 'store/modules/management_store/types';

interface ProgressFilterProps {
  filterRead: boolean;
  setFilterRead: React.Dispatch<React.SetStateAction<boolean>>;
  filterUnread: boolean;
  setFilterUnread: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProgressFilter = (props: ProgressFilterProps) => {
  const { filterRead, setFilterRead, filterUnread, setFilterUnread } = props;

  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  return (
    <div className="d-flex align-items-center">
      <Checkbox
        customClass="checkbox-success mr-4"
        handleChange={() => setFilterRead(!filterRead)}
        label={`Lidas(${management.management_summary.total_progress.read})`}
        checked={filterRead}
        disabled={false}
      />
      <Checkbox
        customClass="checkbox-warning mr-4"
        handleChange={() => setFilterUnread(!filterUnread)}
        label={`Não Lidas(${management.management_summary.total_progress.unread})`}
        checked={filterUnread}
        disabled={false}
      />
    </div>
  );
};

export default ProgressFilter;
